import MeshWithStatsHover from './component'

export default MeshWithStatsHover
